import { PlayCircleIcon, UserGroupIcon, ArrowTrendingUpIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import { Gamepad } from '../../../shared/icons/GamerPad'
import type { SprintPurposeConfigIconName } from 'pure-js/types/SprintPurposeConfig'

export const ICON_MAP: Record<SprintPurposeConfigIconName, React.ComponentType<{ className?: string }>> = {
  PLAY_CIRCLE: PlayCircleIcon,
  USER_GROUP: UserGroupIcon,
  ARROW_TRENDING_UP: ArrowTrendingUpIcon,
  MAGNIFYING_GLASS: MagnifyingGlassIcon,
  GAMEPAD: Gamepad
}
